module.exports = __webpack_public_path__ + "img/pt-10.fe74fca6.jpg";